module.exports = __webpack_public_path__ + "ee49630fb7e07bfbc67d8fdc75e28408.jpg";